import { styled, useTheme } from '@mui/material';
import { Exclusion } from '../../../../types';
import { ExclusionItem } from './ExclusionItem';
import { Typography } from '../../../../components/Typography/Typography';
import { useCompanyExclusions } from '../../../SIngleCompany/hooks/useCompanyExclusions';

import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { selectedCompanyExclusionsState } from '../../../../state/UIState';

const ExclusionsContainer = styled('div')`
  background-color: #fff;
  margin-top: 8px;
  overflow: auto;
  height: ${() => `calc(100% - 122px)`};
`;

const NoExclusionsWrapper = styled('div')`
  margin-top: 8px;
`;

interface Props {
  exclusions: Exclusion[];
}

export const ExclusionsList = ({ exclusions }: Props) => {
  const { colors } = useTheme();
  const { data: companyExclusions } = useCompanyExclusions();
  const [selectedCompanyExclusions, setSelectedCompanyExclusions] = useAtom(
    selectedCompanyExclusionsState
  );

  const existingCompanyExclusionIds = useMemo(() => {
    return companyExclusions?.map((exclusion) => exclusion.id);
  }, [companyExclusions]);

  const companyExclusionIds = useMemo(
    () => selectedCompanyExclusions?.map((exclusion) => exclusion.id) || [],
    [selectedCompanyExclusions]
  );

  const totalExclusionIds = useMemo(() => {
    const companyExclusionIds = selectedCompanyExclusions?.map((exclusion) => exclusion.id) || [];
    return [...existingCompanyExclusionIds, ...companyExclusionIds];
  }, [existingCompanyExclusionIds, selectedCompanyExclusions]);

  const onToggleCheck = (exclusion: Exclusion) => {
    if (companyExclusionIds?.includes(exclusion.id)) {
      setSelectedCompanyExclusions((prev) => {
        return prev.filter((prevItem) => prevItem.id !== exclusion.id);
      });
      return;
    }

    setSelectedCompanyExclusions((prev) => {
      return [...prev, exclusion];
    });
  };

  if (!exclusions?.length) {
    return (
      <NoExclusionsWrapper>
        <Typography variant='body' color={colors.primary[90]} style={{ maxWidth: '600px' }}>
          No exclusions
        </Typography>
      </NoExclusionsWrapper>
    );
  }

  return (
    <ExclusionsContainer>
      {exclusions?.map((exclusion) => {
        return (
          <ExclusionItem
            isChecked={totalExclusionIds?.includes(exclusion.id)}
            isDisabled={existingCompanyExclusionIds?.includes(exclusion.id)}
            key={exclusion.id}
            exclusion={exclusion}
            onToggleCheck={onToggleCheck}
          />
        );
      })}
    </ExclusionsContainer>
  );
};
